// extracted by mini-css-extract-plugin
export default {"container":"styles_container__LeAIb","columns":"styles_columns__TMb6M","column":"styles_column__KFmk5"};